module.exports = __webpack_public_path__ + "img/victora.c5ad96f0.png";